module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/facebook-1c9e4bba0857d2121f4b122e05a84c29.svg&quot;;"